// React Routing + Redux
import { createStore, applyMiddleware, compose } from 'redux';
import { createBrowserHistory } from "history";
import { routerMiddleware } from 'react-router-redux'
import thunk from 'redux-thunk';
import logger from 'redux-logger';
// OIDC
import { loadUser } from 'redux-oidc';
import { UserManager } from './utils';

import rootReducer from './root-reducer';

export const history = createBrowserHistory();;

const middleware = routerMiddleware(history);

const defaultState = {  
};

// added the logger to view store state

const createStoreWithMiddleware = compose(
    applyMiddleware(middleware, thunk, logger)
)(createStore);

const store = createStoreWithMiddleware(rootReducer, defaultState);

loadUser(store, UserManager);

export default store; 